'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  transform: ', ';\n  margin-right: ', ';\n'], ['\n  transform: ', ';\n  margin-right: ', ';\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Component


var IconButton = (0, _styledComponents2.default)(_Icon2.default)(_templateObject, function (_ref) {
  var notransform = _ref.notransform;
  return notransform ? '' : 'translateY(1px)';
}, function (_ref2) {
  var margin = _ref2.margin;
  return margin ? '5px' : '0px';
});
IconButton.propTypes = {
  notransform: _propTypes2.default.number,
  margin: _propTypes2.default.number
};
exports.default = IconButton;